// extracted by mini-css-extract-plugin
module.exports = {"container":"_e8ecc5e","searchResult":"_6046114","secondaryInfo":"_afb14fb"};